import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { ContainedButton } from 'secondstep-components'

const ContinueButton = styled(ContainedButton)`
  background: ${themeGet('colors.buttons.reviewBackground')};
  border-color: ${themeGet('colors.buttons.reviewBackground')};
  color: ${themeGet('colors.buttons.primaryFont')};

  h5 {
    color: ${themeGet('colors.buttons.primaryFont')};
  }

  &:not([disabled]):hover {
    background: ${themeGet('colors.buttons.reviewBackgroundHover')};
    border-color: ${themeGet('colors.buttons.reviewBackgroundHover')};
  }
`

export default ContinueButton
